import PartnerSectionComponent from "./PartnerSectionComponent";

const PartnersSection = ({ id }: any) => {
  return <PartnerSectionComponent id={id} />;
};

export default PartnersSection;
